import React, { useContext } from "react";

import { InfiniteTable } from "../../components";
import Requests from "../../views/Requests";

import { RequestRow } from "./RequestRow";

const headers = [
  "Request ID",
  "Request Type",
  "Brand",
  "Model",
  "Reference Number",
  "Status",
  "Date",
];

export function UserRequests({ user }) {
  return (
    <div className="user-requests-tab__container">
      <Requests user={user} isFromUsersPage />
    </div>
  );
}
